// store/slices/retailerSlice.ts
import { Retailer, RetailerSettings } from '@/types';
import { PayloadAction, createSlice } from '@reduxjs/toolkit';

export type RetailerState = Pick<
  Retailer,
  'id' | 'name' | 'logo' | 'phoneNumber' | 'website' | 'description'
> & {
  settings: Omit<RetailerSettings, 'retailerID'>;
};

const initialState: {
  retailer: RetailerState | null;
} = {
  retailer: null,
};

const retailerSlice = createSlice({
  name: 'retailer',
  initialState,
  reducers: {
    setRetailer: (state, action: PayloadAction<RetailerState | null>) => {
      state.retailer = action.payload;
    },
  },
});

export const { setRetailer } = retailerSlice.actions;
export default retailerSlice.reducer;
